<template>
    <div class="detailedList">

        <!--新增弹出框-->
        <el-dialog :title="dialogTitle":close-on-click-modal=false :visible.sync="dialogVisible" width="917px" :close="handleClose" top="0vh">
            <div class="dialogMain">
                <!--系列海报弹出框-->
                    <el-row :gutter="20" style="text-align: center;">
                        <el-col :span="9">
                            <dl>
                                <dt><span class="checktip">*</span>海报名称：</dt>
                                <dd class="cf">
                                    <el-input v-model="dialogData.name"  placeholder="海报名称"></el-input>
                                </dd>
                            </dl>
                        </el-col>

                        <el-col :span="4">
                            <dl>
                                <dt>
                                    <el-checkbox v-model="dialogData.isTop">置顶</el-checkbox>
                                </dt>
                            </dl>
                        </el-col>
                    </el-row>

                    <el-row :gutter="5">
                        <el-col :span="6">
                            <dl>
                                <dt><span class="checktip">*</span>所属风格：</dt>
                                <dd class="cf">
                                    <el-select
                                            v-model="dialogData.styleId"
                                            :disabled="styleDisable"
                                            placeholder="请选择">
                                        <el-option
                                                v-for="item in styleOptions"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </dd>
                            </dl>
                        </el-col>
                        <el-col :span="6">
                            <dl>
                                <dt><span class="checktip">*</span>所属系列：</dt>
                                <dd class="cf">
                                    <el-select
                                            v-model="dialogData.seriesId"
                                            :disabled="seriesDisable"
                                            placeholder="请选择">
                                        <el-option
                                                v-for="item in seriesOptions"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </dd>
                            </dl>
                        </el-col>
                        <el-col :span="6">
                            <dl>
                                <dt><span class="checktip">*</span>功率：</dt>
                                <dd>
                                    <el-input v-model="dialogData.power" placeholder="请输入功率"></el-input>
                                </dd>
                            </dl>
                        </el-col>
                    </el-row>
            </div>

            <div class="cutOffRule">————————————————————————————— 添加图片 —————————————————————————————</div>
            <div class="dataTag">
                <!--零件筛选-->
                <div class="filtrateMain">
                    <el-row :gutter="15" style="text-align: center;">
                        <el-col :span="5">
                            <el-input v-model="dialogImgData.name" placeholder="名称"></el-input>
                        </el-col>
                        <el-col :span="5" style="line-height: 40px;">
                            <el-button type="primary" size="mini" @click="handleImgSearch()">查询</el-button>
                            <el-button type="warning" size="mini" @click="handleImgReset()">重置</el-button>
                        </el-col>
                    </el-row>
                    <!--筛选结束-->
                </div>
                <!--列表内容-->
                <div class="tableData" style="text-align: center;">
                    <el-table
                            ref="multipleTable"
                            :data="imgLists"
                            border
                            style="width: 100%;border-bottom: 1px solid #ddd;">
                        <el-table-column type="index" label="序号" width="50px">
                        </el-table-column>
                        <el-table-column prop="name" label="图片名称" width="171px">
                        </el-table-column>
                        <el-table-column prop="imgUrl" label="缩略图" width="85px">
                            <template slot-scope="scope">
                                <img :src="scope.row.imgUrl" class="img" height="29px" alt="缩略图"/>
                            </template>
                        </el-table-column>
                        <el-table-column prop="status" label="状态" width="60px">
                            <template slot-scope="scope">
                                {{scope.row.status==1?'上架':'下架'}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="panoramaUrl" label="全景图链接" width="160px">
                            <template slot-scope="scope">
                                <input class="disabledInput" :value="scope.row.panoramaUrl" disabled v-if="scope.row.panoramaUrl"></input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="describe" label="备注" width="100px">
                            <template slot-scope="scope">
                                <input class="disabledInput" :value="scope.row.describe" disabled v-if="scope.row.describe"></input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createTime" label="创建时间" width="151px">
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <a href="javascript:void(0)" @click="addVideoFn(scope.row)" style="color: #1ABC9C;">添加</a>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <!--分页-->
                <div class="page">
                    <el-pagination
                            :current-page="imgListArr.currentPage"
                            :page-sizes="[3]"
                            :page-size="imgListArr.pageSize"
                            layout="total, prev, pager, next"
                            :total="imgListArr.totalSize"
                            @current-change="handleListCurrentChange"
                            @size-change="handleListSizeChange">
                    </el-pagination>
                </div>
            </div>
            <div class="cutOffRule">———————————————————————————— 已添加图片 —————————————————————————————</div>
            <!--列表内容-->
            <div class="tableData" style="text-align: center;">
                <el-table
                        ref="multipleTable"
                        :data="checkList"
                        border
                        height="230"
                        style="width: 100%;border-bottom: 1px solid #ddd;">
                    <el-table-column type="index" label="序号" width="50px">
                    </el-table-column>
                    <el-table-column prop="name" label="图片名称" width="171px">
                    </el-table-column>
                    <el-table-column prop="imgUrl" label="缩略图" width="85px">
                        <template slot-scope="scope">
                            <img :src="scope.row.imgUrl" class="img" height="29px" alt="缩略图"/>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="状态" width="60px">
                        <template slot-scope="scope">
                            {{scope.row.status==1?'上架':'下架'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="panoramaUrl" label="全景图链接" width="160px">
                        <template slot-scope="scope">
                            <input class="disabledInput" :value="scope.row.panoramaUrl" disabled v-if="scope.row.panoramaUrl"></input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="describe" label="备注" width="100px">
                        <template slot-scope="scope">
                            <input class="disabledInput" :value="scope.row.describe" disabled v-if="scope.row.describe"></input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间" width="151px">
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <a href="javascript:void(0)" @click="deleteVideoFn(scope.$index)" style="color: #1ABC9C;">删除</a>
                        </template>
                    </el-table-column>
                </el-table>
                <dl>
                    <dt>&ensp;清单描述：</dt>
                    <dd class="cf">
                        <el-input type="textarea" v-model="dialogData.description" :rows="4" placeholder="描述" ></el-input>
                    </dd>
                </dl>
            </div>
            <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="handleConfirm()" :loading="loading">确 定</el-button>
		    </span>
        </el-dialog>
        <!--主体部分-->
        <div class="mainBody">
            <!--top-->
            <div class="filtrateMain">
                <el-button type="primary" size="mini" @click="handleAdd()">新增</el-button>
                <el-button type="danger" size="mini" @click="handleDelete()">删除</el-button>
                <div class="fr">
                    <div class="fl">
                        <el-input v-model="filtrateData.name" placeholder="名称" class="inputWidth1"></el-input>
                        <el-select v-model="filtrateData.activate" placeholder="是否激活" class="inputWidth1">
                            <el-option v-for="item in activateOptions" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                        <el-select v-model="filtrateData.styleId" placeholder="风格" class="inputWidth1">
                            <el-option key='0' label= '全部' value='0'/>
                            <el-option v-for="item in styleOptions" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                        <el-select v-model="filtrateData.seriesId" placeholder="系列" class="inputWidth1">
                            <el-option key='0' label= '全部' value='0'/>
                            <el-option v-for="item in seriesOptions" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <el-button type="primary" size="mini" @click="handleSearch()" class="searchBtn">查询</el-button>
                    <el-button type="warning" size="mini" @click="handleReset()">重置</el-button>
                </div>
            </div>
            <!--mind-->
            <div class="isZero" v-show="tableData.length<=0">暂无清单</div>
            <!--buttom-->
            <el-row :gutter="20">
                <el-col :xs="12" :sm="10" :md="8" :lg="6" :xl="4" v-for="(item,index) in tableData" :key="index">
                    <div class="details">
                        <div class="check">
                            <el-checkbox @change="checkFn(item.id,index)" :class="'checked'+index"></el-checkbox>
                        </div>
                        <div class="picHide">
                            <div class="imgHide">{{item.name}}({{item.activate==1?'已激活':'未激活'}})</div>
                        </div>
                        <div class="cf remarkHide">
                            {{item.description?'描述：'+item.description:'暂无描述'}}
                            <div class="" v-show="!item.imgList">暂无图片{{item.imgList?item.imgList=item.imgList:item.imgList=[]}}</div>
                            <ol>
                                <li v-for="(list,index1) in item.imgList" :key="index1" :class="list.status==2?'translucence':''"><a href="javascript:void(0);" @click="handleDetail(list)">{{list.name}}</a></li>
                            </ol>
                        </div>
                        <div class="foot cf">
                            <span class="dateTime fl">{{item.createTime}}</span>
                            <a href="javascript:void(0)" class="el-icon-edit fr" @click="handleEdit(item)" style="color: #000;text-decoration: none;"></a>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!--分页-->
        <div class="page">
            <el-pagination
                    background
                    :current-page="tableDataArr.currentPage"
                    :page-sizes="[10,20,30,40]"
                    :page-size="tableDataArr.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataArr.totalSize"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import management from './management.vue'
    import navZcy from './nav.vue'
    export default {
        name: "seriesPoster",
        components:{
            management,
            navZcy,
        },
        data() {
            return {
                checkList: [],
                dialogImgData: {},
                imgLists: [],
                imgListArr: {
                    currentPage: 1,
                    pageSize: 3,
                    totalSize: 0
                },
                loading: false,
                imgListTotal: 0,
                dialogDetailVisible: false,
                dialogDetail: {},
                dialogVisible: false,
                dialogTitle: '',
                dialogData: {},
                dialogListName: '',
                dialogListVisible: false,
                roomDisable:false,
                styleDisable:false,
                seriesDisable:false,
                seriesGroupDisable:false,
                isTop: false,
                tableDataArr: {			//分页
                    currentPage: 1,
                    pageSize: 10,
                    totalSize: 0
                },
                activateOptions: [{
                    id: 1,
                    name: "激活"
                }, {
                    id: 2,
                    name: "未激活"
                }],
                filtrateData:{
                    type:3,
                },
                tableData: [],
                checked: {},
                roomOptions:[],
                seriesOptions:[],
                seriesGroupOptions:[],
                styleOptions: [],
            }
        },
        methods: {
            inquiryImgList: function(){
                var data = {
                    name:this.filtrateData.name==undefined?this.filtrateData.name:this.filtrateData.name.trim(),
                    activate: this.filtrateData.activate,
                    type: this.filtrateData.type,
                    spaceId : this.filtrateData.spaceId,
                    styleId : this.filtrateData.styleId,
                    seriesId : this.filtrateData.seriesId,
                    seriesGroupId : this.filtrateData.seriesGroupId,
                    currentPage: this.tableDataArr.currentPage,
                    pageSize: this.tableDataArr.pageSize,
                    sort:2
                }
                this.$http.post("zcvrVideoApi/imgList/inquiryImgList/"+sessionStorage.getItem('sessionId'),data,{emulateJson:true}).then(
                    (success)=>{
                        console.log(success)
                        if(success.body.msg!="ok"){
                            this.tableData = []
                            this.$message({
                                type: 'error',
                                message: success.data.msg
                            });
                            if(success.data.msg=="该SessionId已经超时"){
                                this.$message.error("登录超时！请重新登录");
                                this.$router.push({path: '/',query: ''})
                            }
                        }else {
                            this.tableDataArr = success.body.data
                            if(this.tableDataArr.items){
                                this.tableData = this.tableDataArr.items
                            }else{
                                this.tableData = []
                            }
                            console.log(this.tableData)
                        }

                    },
                    (error)=>{
                        console.log("数据连接失败")
                    }
                )
            },
            handleImgSearch() {
                this.imgListArr.currentPage = 1
                this.inquiryImg()
            },
            //重置筛选
            handleImgReset() {
                this.dialogImgData = {}
            },
            handleAdd: function() {
                this.loading=false
                this.dialogTitle = "新增清单"
                this.dialogData = {}
                this.checkList = []
                this.dialogVisible = true
                this.dialogData.activate = true
                this.dialogData.type = this.filtrateData.type
            },handleDelete: function() {
                var ids = []
                var checked = this.checked
                Object.keys(checked).forEach(function(key){
                    if(checked[key] == true){
                        ids.push(key)
                    }
                });
                console.log(ids)
                if(ids.length>0){
                    this.$confirm('此操作将永久删除该清单, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$http.get("zcvrVideoApi/imgList/deleteImgList/"+sessionStorage.getItem('sessionId')+"/"+ids,{emulateJson:true}).then(
                            (success)=>{
                                console.log(success)
                                if(success.body.msg=="ok"){
                                    this.$message({
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    this.checked = {}
                                    $('.el-checkbox__input.is-checked').removeClass('is-checked')
                                    this.inquiryImgList()
                                }else{
                                    this.$message({
                                        message: success.data.msg,
                                        type: 'error'
                                    });
                                    if(success.data.msg=="该SessionId已经超时"){
                                        this.$message.error("登录超时！请重新登录");
                                        this.$router.push({path: '/',query: ''})
                                    }
                                }
                            },
                            (error)=>{
                                console.log("数据连接失败")
                            }
                        )
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                }else{
                    this.$message({
                        type: 'info',
                        message: '请选择删除项'
                    });
                }
            },
            handleDetailClose: function(done) {
                done();
            },
            handleListClose: function(done) {
                done();
            },
            handleClose: function(done) {
                this.loading = false
                done();
            },
            handleListCurrentChange(cur){
                this.imgListArr.currentPage = cur
                this.inquiryImg()
            },
            handleListSizeChange(size) {
                this.imgListArr.pageSize = size
                this.inquiryImg()
            },
            //点击页数
            handleCurrentChange(cur) {
                this.tableDataArr.currentPage = cur
                this.inquiryImgList()
            },
            //点击改变显示条目
            handleSizeChange(size) {
                this.tableDataArr.pageSize = size
                this.inquiryImgList()
            },
            addVideoFn(list) {
                this.checkList.push(list)
            },
            deleteVideoFn(index) {
                this.checkList.splice(index, 1);
            },
            inquiryImg: function(){
                var data = {
                    name: this.dialogImgData.name==undefined?this.dialogImgData.name:this.dialogImgData.name.trim(),
                    currentPage: this.imgListArr.currentPage,
                    pageSize: this.imgListArr.pageSize
                }
                this.$http.post("zcvrVideoApi/image/inquiryImg/"+sessionStorage.getItem('sessionId'),data,{emulateJson:true}).then(
                    (success)=>{
                        console.log(success)
                        if(success.body.msg!="ok"){
                            this.$message({
                                type: 'error',
                                message: success.data.msg
                            });
                            if(success.data.msg=="该SessionId已经超时"){
                                this.$message.error("登录超时！请重新登录");
                                this.$router.push({path: '/',query: ''})
                            }
                        }else {
                            this.imgListArr = success.body.data
                            this.imgLists = this.imgListArr.items
                            if(!this.imgListArr.items){
                                this.imgLists = []
                            }
                        }
                    },
                    (error)=>{
                        console.log("数据连接失败")
                    }
                )
            },
            checkFn: function(id, index){
                var len = $('.checked'+index+'.is-checked').length
                if(len==1){
                    this.checked[id] = false
                }else{
                    this.checked[id] = true
                }
            },
            handleEdit: function(item) {
                this.loading=false
                this.dialogTitle = "修改清单"
                this.dialogData = {
                    id: item.id,
                    name: item.name,
                    description: item.description,
                    activate: item.activate==1?true:false,
                    isSeries: item.isSeries==1?true:false,
                    styleId: item.styleId,
                    imgList: item.imgList,
                    spaceId: item.spaceId,
                    seriesId: item.seriesId,
                    seriesGroupId: item.seriesGroupId,
                    type:item.type,
                    isTop:item.isTop == 1,
                    price:item.price,
                    model:item.model,
                    power:item.power,
                }
                this.dialogData.type =  this.dialogData.type==0?'':this.dialogData.type;
                console.log(this.dialogData.type);
                if (this.dialogData.type == '' || this.dialogData.type == 1){
                    this.dialogData.spaceId = '';
                    this.dialogData.styleId = '';
                    this.dialogData.seriesId = '';
                    this.dialogData.seriesGroupId = '';
                }
                this.handlePictureSelectChange(this.dialogData.type)
                const retvalue1 = this.roomOptions.find((value) =>{
                    if (value.id == this.dialogData.spaceId) {
                        return value;
                    }
                });
                if (!retvalue1)
                {
                    this.dialogData.spaceId = '';
                }
                const retvalue2 = this.styleOptions.find((value) =>{
                    if (value.id == this.dialogData.styleId) {
                        return value;
                    }
                });
                if (!retvalue2)
                {
                    this.dialogData.styleId = '';
                }
                const retvalue3 = this.seriesOptions.find((value) =>{
                    if (value.id == this.dialogData.seriesId) {
                        return value;
                    }
                });
                if (!retvalue3)
                {
                    this.dialogData.seriesId = '';
                }
                const retvalue4 = this.seriesGroupOptions.find((value) =>{
                    if (value.id == this.dialogData.retvalue4) {
                        return value;
                    }
                });
                if (!retvalue4)
                {
                    this.dialogData.retvalue4 = '';
                }
                this.checkList = [].concat(item.imgList)
                this.dialogVisible = true
            },
            handleConfirm: function() {
                if(this.dialogData.name==""||!this.dialogData.name){
                    this.$message({
                        type: 'info',
                        message: '请输入名称'
                    });
                    return
                }
                if(!this.dialogData.type){
                    this.$message({
                        type: 'info',
                        message: '请选所属图片类型'
                    });
                    return
                }
                var imageIds = []
                for (var i=0; i<this.checkList.length; i++) {
                    imageIds.push(this.checkList[i].id)
                }
                this.loading=true
                var data = {
                    name: this.dialogData.name.trim(),
                    imageIds: imageIds,
                    activate: this.dialogData.activate?1:2,
                    isSeries: this.dialogData.isSeries?1:2,
                    styleId: this.styleDisable?0:this.dialogData.styleId,
                    description: this.dialogData.description,
                    type:this.filtrateData.type,//this.dialogData.type,
                    spaceId:this.roomDisable?0:this.dialogData.spaceId,
                    seriesId:this.seriesDisable?0:this.dialogData.seriesId,
                    seriesGroupId:this.seriesGroupDisable?0:this.dialogData.seriesGroupId,
                    isTop:this.dialogData.isTop?1:0,
                    price:parseInt(this.dialogData.price),
                    model:this.dialogData.model==undefined?this.dialogData.model:this.dialogData.model.trim(),
                    power:this.dialogData.power==undefined?this.dialogData.power:this.dialogData.power.trim(),
                }
                var url = ""
                if(!this.dialogData.id){
                    url = "zcvrVideoApi/imgList/createImgList/"+sessionStorage.getItem('sessionId')
                }else{
                    data.id = this.dialogData.id
                    url = "zcvrVideoApi/imgList/updateImgList/"+sessionStorage.getItem('sessionId')
                }

                console.log(data)
                this.$http.post(url,data,{emulateJson:true}).then(
                    (success)=>{
                        this.loading=false
                        console.log(success)
                        if(success.data.msg=="ok"){
                            this.dialogVisible = false
                            this.inquiryImgList()
                        }else {
                            this.$message({
                                message: success.data.msg,
                                type: 'error'
                            });
                            if(success.data.msg=="该SessionId已经超时"){
                                this.$message.error("登录超时！请重新登录");
                                this.$router.push({path: '/',query: ''})
                            }
                        }
                    },
                    (error)=>{
                        console.log("数据连接失败")
                    }
                )
            },
            handlePictureSelectChange(value){
                switch (value) {
                    case 1:
                        this.roomDisable = true;
                        this.styleDisable= true;
                        this.seriesDisable= true;
                        this.seriesGroupDisable = true;
                        this.dialogData.type = value;
                        break;
                    case 2:
                        this.roomDisable = false;
                        this.styleDisable= false;
                        this.seriesDisable= false;
                        this.seriesGroupDisable = false;
                        this.dialogData.type = value;
                        break;
                    case 3:
                        this.roomDisable = false;
                        this.styleDisable= false;
                        this.seriesDisable= false;
                        this.seriesGroupDisable = false;
                        this.dialogData.type = value;
                        break;
                    case 4:
                        this.roomDisable = false;
                        this.styleDisable= false;
                        this.seriesDisable= false;
                        this.seriesGroupDisable = false;
                        this.dialogData.type = value;
                        break;
                }
            },
            getStyle() {
                this.$http.post("zcvrVideoApi/imgList/getImgStyle/"+sessionStorage.getItem('sessionId'),{emulateJson:true}).then(
                    (success)=>{
                        //		  				console.log(success)
                        if(success.body.msg!="ok"){
                            this.styleOptions = []
                            this.$message({
                                type: 'error',
                                message: success.data.msg
                            });
                            if(success.data.msg=="该SessionId已经超时"){
                                this.$message.error("登录超时！请重新登录");
                                this.$router.push({path: '/',query: ''})
                            }
                        }else {
                            this.styleOptions = success.body.data
                        }

                    },
                    (error)=>{
                        console.log("数据连接失败")
                    })
            },
            getRoom() {
                this.$http.post("zcvrVideoApi/imgList/getSpace/"+sessionStorage.getItem('sessionId'),{emulateJson:true}).then(
                    (success)=>{
//		  				console.log(success)
                        if(success.body.msg!="ok"){
                            this.roomOptions = []
                            this.$message({
                                type: 'error',
                                message: success.data.msg
                            });
                            if(success.data.msg=="该SessionId已经超时"){
                                this.$message.error("登录超时！请重新登录");
                                this.$router.push({path: '/',query: ''})
                            }
                        }else {
                            this.roomOptions = success.body.data;
                        }

                    },
                    (error)=>{
                        console.log("数据连接失败")
                    })
            },
            getSeries() {
                this.$http.post("zcvrVideoApi/imgList/getSeries/"+sessionStorage.getItem('sessionId'),{emulateJson:true}).then(
                    (success)=>{
//		  				console.log(success)
                        if(success.body.msg!="ok"){
                            this.seriesOptions = []
                            this.$message({
                                type: 'error',
                                message: success.data.msg
                            });
                            if(success.data.msg=="该SessionId已经超时"){
                                this.$message.error("登录超时！请重新登录");
                                this.$router.push({path: '/',query: ''})
                            }
                        }else {
                            this.seriesOptions = success.body.data
                        }

                    },
                    (error)=>{
                        console.log("数据连接失败")
                    })
            },
            getSeriesGroup() {
                this.$http.post("zcvrVideoApi/imgList/getSeriesGroup/"+sessionStorage.getItem('sessionId'),{emulateJson:true}).then(
                    (success)=>{
//		  				console.log(success)
                        if(success.body.msg!="ok"){
                            this.seriesGroupOptions = []
                            this.$message({
                                type: 'error',
                                message: success.data.msg
                            });
                            if(success.data.msg=="该SessionId已经超时"){
                                this.$message.error("登录超时！请重新登录");
                                this.$router.push({path: '/',query: ''})
                            }
                        }else {
                            this.seriesGroupOptions = success.body.data
                        }

                    },
                    (error)=>{
                        console.log("数据连接失败")
                    })
            },
            handleSearch: function() {
                this.tableDataArr.currentPage = 1
                this.inquiryImgList()
            },
            handleReset: function(){
                this.filtrateData = {}
                this.filtrateData.type = 3
                this.inquiryImgList()
            },
        },
        mounted() {
            this.getStyle()
            this.getRoom()
            this.getSeries()
            this.getSeriesGroup()
            this.inquiryImg()
            this.inquiryImgList()
        }
    }
</script>

<style scoped>
    /*公用的*/
    .fl{
        float: left;
    }
    .fr{
        float: right;
    }
    .cf{
        overflow: hidden;
    }
    .translucence{
        opacity: 0.5;
    }
    .translucence a{
        text-decoration: line-through !important;
    }
    .videoOuter{
        width: 100%;
        height: 100%;
        position: fixed;
        top:0px;
        padding-top: 10%;
        z-index: 1000;
        background: rgba(0,0,0,0.5);
    }
    .video{
        display: inline-block;
        vertical-align: middle;
        width: 80%;
        height: 70%;
        margin: 0 auto;
    }
    .tooltip{
        padding-left: 10px;
    }
    .videoImg{
        width: 250px;
        cursor: pointer;
    }
    .imgList{
        padding: 0 10px;
        margin-right: 10px;
        margin-bottom: 10px;
        border: 1px solid #eee;
    }
    .addVideo,.deleteVideo{
        cursor: pointer;
    }
    .addVideo:hover{
        color: #67c23a;
        border-color: #67c23a;
    }
    .deleteVideo:hover{
        color: #000;
        border-color: #000;
    }
    .sequence{
        overflow: auto;
        margin-bottom: 10px;
        padding-bottom: 5px;
    }

    .sequence::-webkit-scrollbar{
        width: 16px;
        height: 10px;
        background-color: #F5F5F5;
    }
    .sequence::-webkit-scrollbar-track{
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
        background-color: #F5F5F5;
    }
    .sequence::-webkit-scrollbar-thumb{
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
        background-color: #555;
    }
    .checkList{
        cursor: pointer;
        padding: 10px;
        margin-right: 10px;
        white-space: nowrap;
        border: 1px solid #eee;
    }
    .checkList.active{
        color: #67c23a;
        border-color: #67c23a;
    }
    .checkList:hover{
        color: #67c23a;
        border-color: #67c23a;
    }
    .listPaging{
        line-height: 20px;
    }
    .mainBody{
        padding: 20px;
    }
    .filtrateMain{
        padding-bottom: 20px;
    }
    .filtrateMain .searchBtn{
        margin-left: 20px;
    }
    .inputWidth1{
        width: 120px;
        margin-left: 10px;
    }
    .details{
        position: relative;
        margin-bottom: 20px;
        border: 1px solid #eee;
        box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.1);
    }
    .isZero{
        text-align: center;
        padding: 50px;
    }
    .check{
        position: absolute;
        top: 0;
        right: 0;
        z-index: 10;
        background: #fff;
        padding: 0 5px;
    }
    .picHide{
        height: 70px;
        width: 100%;
        overflow: hidden;
        border-bottom: 1px solid #eee;
    }
    .picHide .imgHide{
        width:100%;
        padding: 10px 20px;
        background: #fff;
        color: #2a72c5;
        font-weight: bold;
        line-height: 25px;
        height: 70px;
        box-sizing: border-box;
    }
    .remarkHide{
        padding: 5px 20px;
        height: 155px;
        overflow-y: auto;
        overflow-wrap: break-word;
    }
    .mainBody ol{
        margin: 10px 0;
        padding-left: 25px;
    }
    .dialogMain ol{
        margin: 0;
    }
    .mainBody a, .dialogMain a{
        color: #000000;
        text-decoration: none;
    }
    .mainBody a:hover, .dialogMain a:hover{
        text-decoration: underline;
    }
    .foot{
        padding: 10px 15px;
        border-top: 1px solid #eee;
    }
    .dateTime{
        color: #838383;
        font-size: 10px;
        line-height: 20px;
        margin-bottom: 0px;
    }
    .page{
        text-align: center;
    }
    .disabledInput{
        width: 100%;
        border: none;
        background: rgba(0,0,0,0);
        text-align: center;
    }
    .cutOffRule {
        text-align: center;
        padding: 5px 0;
    }
</style>

